import SalesCards from './salesCard';
export default function SalesAccordion(){




const flightData = [
  {
    id: 1,
    route: "ARN-LHR-CPH",
    uplift: "ARN",
    date: "1 Jul 2025, 02:00",
    posPending: 2,
    groupSales: "€93.26",
    sectors: [
      {
        name: "ARN-LHR",
        flight: "SK202",
        sta: "02:27",
        ata: "02:31",
        sales: "€25.81",
        passengers: [
          {
            name: "Ms. Jones",
            seat: "3B",
            pnr: "A1F1TE",
            ssr: "PML",
            crew: "Erik Gustavsson",
            pos: "POS_F9A5AD",
            payment: "Voucher",
            amount: "€9.06",
            items: [{
    "itemName": "Gin Miniature",
    "unit": "NOS",
    "quantity": 3,
    "totalAmountInUsedCurrency": 300
}]
          },
          {
            name: "Mrs. O’Connell",
            seat: "10C",
            pnr: "JCD4E2",
            ssr: "",
            crew: "Lena Holm",
            pos: "POS_EA5D25",
            payment: "Cash",
            amount: "€5.94",

            items: [{
    "itemName": "SkyBites Sandwich",
    "unit": "NOS",
    "quantity": 2,
    "totalAmountInUsedCurrency": .80
}]
          },
          {
            name: "Ms. Dubois",
            seat: "10D",
            pnr: "SX0HX4",
            ssr: "WCHR",
            crew: "Lena Holm",
            pos: "POS_EA5D25",
            payment: "-",
            amount: "€0.00",
            items: []
          },
          {
            name: "Mr. Andersson",
            seat: "15F",
            pnr: "8PWZIP",
            ssr: "PETC",
            crew: "Sean Kelly",
            pos: "POS_73A9BD",
            payment: "Split Payment",
            amount: "€10.81",
            items: []
          }
        ]
      },
      {
        name: "LHR-CPH",
        flight: "SK201",
        sta: "03:38",
        ata: "04:53",
        sales: "€67.45",
        passengers: [{
            name: "Ms. Dubois",
            seat: "10D",
            pnr: "SX0HX4",
            ssr: "WCHR",
            crew: "Lena Holm",
            pos: "POS_EA5D25",
            payment: "-",
            amount: "€0.00",
            items: ['No Items']
          },]
      }
    ]
  },
  {
    id: 2,
    route: "CPH-DUB-LHR",
    uplift: "CPH",
    date: "1 Jul 2025, 04:00",
    posPending: 1,
    groupSales: "€117.18",
    sectors: [
      {
        name: "CPH-DUB",
        flight: "SK310",
        sta: "05:15",
        ata: "05:21",
        sales: "€72.34",
        passengers: [
          {
            name: "Mr. Brown",
            seat: "2A",
            pnr: "X1YZ20",
            ssr: "VGML",
            crew: "Amelia Craig",
            pos: "POS_A1B2C3",
            payment: "Credit",
            amount: "€12.00",

            items: [{
    "itemName": "Vodka Miniature",
    "unit": "NOS",
    "quantity": 2,
    "totalAmountInUsedCurrency": .20
},
{
    "itemName": "Mixed Nuts",
    "unit": "NOS",
    "quantity": 3,
    "totalAmountInUsedCurrency": .80
}]
          }
        ]
      },
      {
        name: "DUB-LHR",
        flight: "SK311",
        sta: "06:50",
        ata: "07:10",
        sales: "€44.84",
        passengers: [
          {
            name: "Mrs. White",
            seat: "7C",
            pnr: "KL890Z",
            ssr: "",
            crew: "Jonas Skov",
            pos: "POS_D9F1Z8",
            payment: "Cash",
            amount: "€8.45",
            items: ["Snack Box (Qty: 1)"]
          }
        ]
      }
    ]
  },
  {
    id: 3,
    route: "CPH-OSL",
    uplift: "CPH",
    date: "1 Jul 2025, 06:00",
    posPending: 1,
    groupSales: "€18.38",
    sectors: [
      {
        name: "CPH-OSL",
        flight: "SK410",
        sta: "07:10",
        ata: "07:55",
        sales: "€18.38",
        passengers: [
          {
            name: "Mr. Singh",
            seat: "9F",
            pnr: "PQ345X",
            ssr: "HNML",
            crew: "Anna Berg",
            pos: "POS_Y7W6E2",
            payment: "Card",
            amount: "€18.38",

            items: [{
    "itemName": "Coke Zero",
    "unit": "NOS",
    "quantity": 5,
    "totalAmountInUsedCurrency": .85
},
{
    "itemName": "Chicken Wrap",
    "unit": "NOS",
    "quantity": 3,
    "totalAmountInUsedCurrency": .56
}]
          }
        ]
      }
    ]
  },
    {
    id: 4,
    route: "CRN-FHD-GPH",
    uplift: "CRN",
    date: "1 Jul 2025, 02:00",
    posPending: 5,
    groupSales: "€43.26",
    sectors: [
      {
        name: "CRN-GPH",
        flight: "SK502",
        sta: "02:27",
        ata: "02:31",
        sales: "€55.81",
        passengers: [
          {
            name: "Ms. Jones",
            seat: "3B",
            pnr: "A1F1TE",
            ssr: "PML",
            crew: "Erik Gustavsson",
            pos: "POS_F9A5AD",
            payment: "Voucher",
            amount: "€9.06",
            items: [{
    "itemName": "Gin Miniature",
    "unit": "NOS",
    "quantity": 3,
    "totalAmountInUsedCurrency": 300
}]
          },
          {
            name: "Mrs. O’Connell",
            seat: "10C",
            pnr: "JCD4E2",
            ssr: "",
            crew: "Lena Holm",
            pos: "POS_EA5D25",
            payment: "Cash",
            amount: "€5.94",

            items: [{
    "itemName": "SkyBites Sandwich",
    "unit": "NOS",
    "quantity": 2,
    "totalAmountInUsedCurrency": .80
}]
          },
          {
            name: "Ms. Dubois",
            seat: "10D",
            pnr: "SX0HX4",
            ssr: "WCHR",
            crew: "Lena Holm",
            pos: "POS_EA5D25",
            payment: "-",
            amount: "€0.00",
            items: []
          },
          {
            name: "Mr. Andersson",
            seat: "15F",
            pnr: "8PWZIP",
            ssr: "PETC",
            crew: "Sean Kelly",
            pos: "POS_73A9BD",
            payment: "Split Payment",
            amount: "€10.81",
            items: []
          }
        ]
      },
      {
        name: "LHR-CPH",
        flight: "SK201",
        sta: "03:38",
        ata: "04:53",
        sales: "€67.45",
        passengers: [{
            name: "Ms. Dubois",
            seat: "10D",
            pnr: "SX0HX4",
            ssr: "WCHR",
            crew: "Lena Holm",
            pos: "POS_EA5D25",
            payment: "-",
            amount: "€0.00",
            items: ['No Items']
          },]
      }
    ]
  },
];


  return (
    <div className='flexCol'>
       {flightData.map((flight) => (
        <SalesCards flight={flight} key={flight.id} />
      ))}
    </div>
  );
}